import { makeStyles } from '@rbx/ui';

const useMarkdownCodeBlockStyles = makeStyles()(() => ({
  root: {
    maxWidth: '100%',
    margin: 0,
    // hard set to 14px so it doesn't inherit the font size from the parent
    fontSize: 14,
    '& > div': {
      margin: '0 !important',
    },
  },
  minimalCodeBlock: {
    marginBottom: '16px',
  },
}));

export default useMarkdownCodeBlockStyles;
